import React, { useEffect, useState, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const App = () => {
  const { instance, accounts } = useMsal();
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Get file path from query string
    const params = new URLSearchParams(window.location.search);
    const filePath = params.get("file");

    // Get client name from first path segment: /clientname?file=...
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const clientFromPath = pathParts[0] || null;

    if (filePath) {
      sessionStorage.setItem("downloadFilePath", filePath);
      // Extract page number if filename ends with _P{number} and any extension
      // Example: ..._P10.pdf, ..._P4.docx, ..._P12.txt
      const match = filePath.match(/_P(\d+)\.[^./]+$/);
      if (match) {
      sessionStorage.setItem("pageNumber", match[1]);
      }
    }
    if (clientFromPath) {
      sessionStorage.setItem("client", clientFromPath);
    }
  }, []);

  const initiateDownload = useCallback(async (accessToken) => {
    try {
      const filePath = sessionStorage.getItem("downloadFilePath");
      const client = sessionStorage.getItem("client");
      if (!filePath) throw new Error("No file path specified");
      if (!client) throw new Error("No client specified in subdomain");
      const pageNumber = sessionStorage.getItem("pageNumber");

      const url = `/download?client=${encodeURIComponent(client)}&file=${encodeURIComponent(filePath)}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch signed URL");
      const { signedUrl } = await response.json();

      const redirectUrl = pageNumber ? `${signedUrl}#page=${pageNumber}` : signedUrl;
      window.location.href = redirectUrl;
    } catch (error) {
      console.error("Download failed:", error);
    }
  }, []);

  useEffect(() => {
    const loginAndGetToken = async () => {
      const loginAttempted = sessionStorage.getItem("loginAttempted");
      const currentAccounts = instance.getAllAccounts();

      if (currentAccounts.length === 0) {
        if (!loginAttempted) {
          sessionStorage.setItem("loginAttempted", "true");
          instance.loginRedirect(loginRequest);
        } else {
          console.warn("Login already attempted. Not redirecting again.");
        }
      } else {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: currentAccounts[0],
          });
          setToken(response.accessToken);
          initiateDownload(response.accessToken);
        } catch (err) {
          console.warn("Silent token acquisition failed:", err.message);
          if (!loginAttempted) {
            sessionStorage.setItem("loginAttempted", "true");
            instance.acquireTokenRedirect(loginRequest);
          } else {
            console.warn("Token acquisition failed after redirect. Not trying again.");
          }
        }
      }
    };

    loginAndGetToken();
  }, [instance]);

  useEffect(() => {
    if ((window.location.pathname === "/amazonq/callback" || window.location.pathname === "/callback") && token) {
      console.log("Token acquired:", token);
      console.log("Triggering download for:", window.location.pathname);
      initiateDownload(token);
    }
  }, [token, initiateDownload]);

  return (
    <div>
      {token ? (
        <h3>Preparing download...</h3>
      ) : (
        <h3>Logging in...</h3>
      )}
    </div>
  );
};

export default App;
